var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottomRight"},[_c('transition',{attrs:{"name":"pop-up","appear":"","mode":"out-in"}},[(_vm.shouldShow)?_c('div',{staticClass:"circular primary clickable",on:{"click":_vm.handleClick}},[_c('BaseIcon',{staticClass:"icon",attrs:{"name":"arrow-up"}})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }